// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.head{
    display: flex;
    /* justify-content: space-between; */
}

.headLabel{
 width: 100%;
justify-content: space-between    
}`, "",{"version":3,"sources":["webpack://./src/app/users-management/user-group/add-edit-user-group/add-edit-user-group.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oCAAoC;AACxC;;AAEA;CACC,WAAW;AACZ;AACA","sourcesContent":[".head{\r\n    display: flex;\r\n    /* justify-content: space-between; */\r\n}\r\n\r\n.headLabel{\r\n width: 100%;\r\njustify-content: space-between    \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
